import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const CreateEvent = () => {
  const navigate = useNavigate();

  const handleCreateEventClick = () => {
    // Always start Create flow fresh from this entry point.
    sessionStorage.removeItem("event-flow:create");
    sessionStorage.removeItem("event-tab:create");
    navigate('/create-events');
  };

  return (
    <div
      className="p-4 d-flex align-items-center justify-content-between flex-wrap shadow-sm rounded"
      style={{
        background: 'linear-gradient(to bottom right, #002147, #3053a2)',
        color: 'white',
        borderRadius: '1rem',
      }}
    >
      {/* Text Section */}
      <div className="mb-3 mb-lg-0" style={{ flex: 1, minWidth: 260 }}>
        <h3 className="fw-bold mb-2">Got an idea?</h3>
        <h3 className="fw-bold mb-3">Share it with the world.</h3>
        <p className="mb-4">Pick a date, choose style, go live.</p>
        <Button
          variant="warning"
          className="fw-semibold"
          onClick={handleCreateEventClick}
        >
          Create Event
        </Button>
      </div>

      {/* Image Section */}
      <div style={{ flex: 1, textAlign: 'right', minWidth: 260 }}>
        <img
          src="/assets/images/createevent.png"
          alt="Create Event"
          style={{ maxHeight: 230, maxWidth: '100%' }}
        />
      </div>
    </div>
  );
};

export default CreateEvent;
